import { tradeApi } from '@lib/axios';
import { apiCall } from './api-utils';

const BASE = '/v1';

export const fetchBrokers = (status) => {
  const url = status ? `${BASE}/brokers?status=${status}` : `${BASE}/brokers`;
  return apiCall(() => tradeApi.get(url), 'fetchBrokers');
};

export const createBroker = (params) =>
  apiCall(() => tradeApi.post(`${BASE}/brokers`, params), 'createBroker');

export const removeBrokerById = (brokerId) =>
  apiCall(() => tradeApi.delete(`${BASE}/brokers/${brokerId}`), 'removeBrokerById');

export const logoutBroker = (brokerId) =>
  apiCall(() => tradeApi.get(`${BASE}/brokers/${brokerId}/logout`), 'logoutBroker');

export const updateBrokerSettings = (brokerId, params) =>
  apiCall(() => tradeApi.put(`${BASE}/brokers/${brokerId}`, params), 'updateBrokerSettings');

export const fetchBrokerCount = () =>
  apiCall(() => tradeApi.get(`${BASE}/brokers/count`), 'fetchBrokerCount');

export const fetchLoginCheck = () =>
  apiCall(() => tradeApi.get(`${BASE}/login-check`), 'fetchLoginCheck');

export const setBrokerPurpose = (brokerId, purpose) =>
  apiCall(() => tradeApi.post(`${BASE}/brokers/${brokerId}/purpose`, { purpose }), 'setBrokerPurpose');